import { Object3D } from 'three';

export function create_scene_node(node_name: string) {
    const n = new Object3D();
    n.position.x = 0;
    n.position.y = 0;
    n.position.z = 0;
    n.rotation.x = 0;
    n.rotation.y = 0;
    n.rotation.z = 0;
    n.scale.x = 1;
    n.scale.y = 1;
    n.scale.z = 1;
    n.name = node_name;
    return n;
}

export function reset_scene_node(n: Object3D) {
    n.position.x = 0;
    n.position.y = 0;
    n.position.z = 0;
    n.rotation.x = 0;
    n.rotation.y = 0;
    n.rotation.z = 0;
    n.scale.x = 1;
    n.scale.y = 1;
    n.scale.z = 1;
    n.children.length = 0;
}
